import PropTypes from "prop-types";
import React from "react";

import SVGIcon from "~components/utils/svg_icon/svg_icon";

import { trailingIconStyle } from "./input_trailing_icon.module.scss";

export default function InputTrailingIcon({ icon, iconSize }) {
  return (
    <div className={trailingIconStyle}>
      <SVGIcon
        icon={icon}
        width={iconSize}
        height={iconSize}
        color="cloudBurst50"
      />
    </div>
  );
}

InputTrailingIcon.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.number,
};

InputTrailingIcon.defaultProps = {
  icon: "",
  iconSize: 20,
};
